// extracted by mini-css-extract-plugin
export default {"cls1":"ZsmDrbbKSlH40LUWM1Vn","cls2":"mf37zX1DdA5_KMMCmoig ZsmDrbbKSlH40LUWM1Vn"};